<template lang="pug">
  v-app
    component(:is="layout")
      router-view

    Notify
</template>

<script>

import Notify from './components/widgets/Notify'

export default {
  name: 'App',

  metaInfo: {
    title: 'WWP Admin',
    // override the parent template and just use the above title only
    titleTemplate: null
  },

  components: {
    Notify
  },

  data: () => ({
    //
  }),

  computed: {
    layout() {
      return (this.$route.meta.layout ? this.$route.meta.layout : 'default') + '-layout'
    }
  },

  methods: {
    goToNewsList() {
      this.$router.push({
        name: 'banners__list'
      })
    }
  },

  mounted() {
    if (window.location.pathname === '/') {
      this.goToNewsList()
    }
  },

  watch: {
    $route(to, from) {
      if (to.name === 'home') {
        this.goToNewsList()
      }
    }
  }
}
</script>
